import React from "react";
//#region types
import { SimpleAccordionTableProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { Grid, Table, TableBody } from "@mui/material";
import SimpleAccordionTableRow from "./row";
//#endregion

const SimpleAccordionTable: React.FC<SimpleAccordionTableProps> = ({
  items,
  variant,
  emphasisValue,
  defaultExpanded,
}) => {
  return (
    <Grid item container>
      <Table>
        <TableBody>
          {items.map((item, index) => (
            <SimpleAccordionTableRow
              key={index}
              {...item}
              variant={variant}
              emphasisValue={item.emphasisValue ?? emphasisValue}
              defaultExpanded={defaultExpanded}
            />
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default SimpleAccordionTable;
